export default "__VITE_ASSET__owC4kYZu__"